
import { PlayerEnvironment } from './player_environment';

export class PlayerFocus {
    constructor({ idleTime, data } = {}) {
        this.idleTime = idleTime;
        this.idleTimer = null;
        this._data = data;


        if (this.isWatchPage() == true) {
            this.initializeEventListeners();
        }
    }

    startIdleTimer() {
        this.idleTimer = setTimeout(() => {
            this.focus();
        }, this.idleTime);
    }

    resetIdleTimer() {
        clearTimeout(this.idleTimer);
        this.startIdleTimer();
    }

    initializeEventListeners() {
        this.startIdleTimer();

        window.addEventListener("mousemove", this.resetIdleTimer.bind(this));
        window.addEventListener("keydown", this.resetIdleTimer.bind(this));
    }

    isWatchPage() {
        // Is This Live / VOD Watchpage?
        const patern = /^(\/(watch|live)(\/[^/]+)?)\/?$/;
        return patern.test(PlayerEnvironment.pathname());
    }

    isNotOnChatOrCommentSection() {
        const currentFocus = document.activeElement;

        // Livestreaming Chat
        if (currentFocus.classList.contains('livestreaming-discussion__input')) {
            return false;
        }

        // VOD Commend Section
        if (currentFocus.classList.tagName == 'TEXTAREA') {
            return false;
        }

        return true;
    }

    isPlayerVisible(player) {
        if (!player) return false;

        const boundingBox = player.getBoundingClientRect();

        var isVisible =
        boundingBox.top >= 0 &&
        boundingBox.left >= 0 &&
        boundingBox.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        boundingBox.right <= (window.innerWidth || document.documentElement.clientWidth);

        return isVisible;
    }

    focus() {
        const player = document.querySelector('video');
        if (!player) return;

        if (this.isPlayerVisible(player) && this.isNotOnChatOrCommentSection()) {
            player.focus();
        }
    }
}
